if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true' || this.form.dataset.savaVariantPending === 'true' || this.savaSubmitting) return;

      this.handleErrorMessage();
      const preorder = this.form.querySelector('[data-sava-preorder-state]');
      const requestedVariantId = String(this.form.querySelector('[name=id]').value);
      const productUrl = preorder?.dataset.productUrl || this.closest('.shopify-section')?.querySelector('variant-selects,variant-radios')?.dataset.url;
      const controls = Array.from(this.closest('.shopify-section')?.querySelectorAll('variant-selects input,variant-selects select,variant-radios input,variant-radios select') || []).map(el => [el,el.disabled]);
      const submitWasDisabled = this.submitButton.disabled;
      this.savaSubmitting = true;
      this.submitButton.disabled = true;
      controls.forEach(([el]) => { el.disabled = true; });
      const releaseValidation = () => { this.savaSubmitting = false; controls.forEach(([el,disabled]) => { el.disabled = disabled; }); if (this.form.dataset.savaVariantPending !== 'true') this.submitButton.disabled = submitWasDisabled; };
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      let validatedState;
      try {
        if (!window.SavaPreorder || !productUrl) throw new Error('Unable to verify this item. Please refresh and try again.');
        validatedState = await window.SavaPreorder.validate(productUrl, requestedVariantId);
        if (String(this.form.querySelector('[name=id]').value) !== requestedVariantId || this.form.dataset.savaVariantPending === 'true') throw new Error('Your selection changed. Please wait and try again.');
        if (!validatedState.available) throw new Error(window.variantStrings?.soldOut || 'This size is sold out.');
        window.SavaPreorder.syncForm(this.form, validatedState);
      } catch (error) {
        this.handleErrorMessage(error.message || 'Unable to verify this item. Please try again.');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        releaseValidation();
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      window.SavaPreorder.sanitizeFormData(formData, validatedState);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          releaseValidation();
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}



